<div mat-dialog class="adjust-home-dialog">
    <lgv-loading-indicator *ngIf="isLoading$ | async"></lgv-loading-indicator>
    <mat-dialog-content style="min-height: 570px;">
        <h6 class="header">Adjust Home Value</h6>
        <div class="Vert-20"></div>
        <p>AVM is an estimate of your home value. Changes made here will affect all other values shown on HomeDashboard.
            <br><a style="cursor: pointer;" (click)="showAvmDialog()">Learn more about AVM.</a>
        </p>
        <div class="Vert-10"></div>
        <p>Your updated home value is:</p>
        <form [formGroup]="homeValueForm">
            <div class="row">
                <mat-form-field class="col-6" appearance="outline" floatLabel="always">
                    <mat-label>Adjusted Home Value</mat-label>
                    <span matPrefix>$&nbsp;</span>
                    <input type="number" matInput formControlName="homeValue">
                    <mat-error *ngIf="homeValueForm.controls.homeValue.errors?.required">
                        Home value is required
                    </mat-error>
                    <mat-error *ngIf="homeValueForm.controls.homeValue.errors?.greaterThanHighLimit">
                        Home value should be less than or equal the 10% of High AVM
                    </mat-error>
                    <mat-error *ngIf="homeValueForm.controls.homeValue.errors?.lessThanLowLimit">
                        Home value should be greater than or equal the -10% of Low AVM
                    </mat-error>
                </mat-form-field>
                <mat-form-field class="col-6" appearance="outline" floatLabel="always">
                    <mat-label>Value Percent</mat-label>
                    <span matSuffix>%&nbsp;</span>
                    <input type="number" matInput formControlName="percent">
                    <mat-error *ngIf="homeValueForm.controls.homeValue.errors?.required">
                        Percent is required
                    </mat-error>
                </mat-form-field>
            </div>
            <div class="Vert-20"></div>

            <div class="row">
                <mat-form-field class="col-12" appearance="outline" floatLabel="always">
                    <mat-label>Reason for Adjustment</mat-label>
                    <mat-select formControlName="reason">
                        <mat-option *ngFor=" let reason of adjustmentReason$ | async " [value]="reason.id">
                            {{reason.name}}</mat-option>
                    </mat-select>
                </mat-form-field>
            </div>
            <a style="margin-top: -20px; cursor: pointer;" (click)="resetCalc()">Reset</a>
        </form>
        <div class="Vert-50"></div>
        <div class="Vert-30"></div>

        <div class="row">
            <div class="slidecontainer col-12">
                <input type="range" [min]="sliderMin" steps="1" [max]="sliderMax" [(ngModel)]="sliderValue"
                    (ngModelChange)="sliderValueChanged($event)" class="slider" id="myRange">
                <div class="current-value">
                     $ {{sliderValue | number: '1.0-0'}} <br> 
                     <span style="font-size: 12px; font-weight: 400;">Adjusted Value</span>
                </div>
            </div>
        </div>
        <div class="row" style="padding: 10px 20px;">
            <div class="col-4 flex-center" (click)="setLowValue()">
                <div class="sticky-line-container">
                    <div class="sticky-mark-low"></div>
                </div>
                <strong>$ {{homeValueDetails?.lowValue | number: '1.0-0'}}</strong>
                <span>Low AVM</span>
            </div>
            <div class="col-4 flex-center">
                <strong>$ {{currentAvm | number: '1.0-0'}}</strong>
                <span>Current AVM*</span>
            </div>
            <div class="col-4 flex-center" (click)="setHighValue()">
                <div class="sticky-line-container">
                    <div class="sticky-mark-high"></div>
                </div>
                <strong>$ {{homeValueDetails?.highValue | number: '1.0-0'}}</strong>
                <span>High AVM</span>
            </div>
        </div>


        <div class="Vert-30"></div>

        <p style="font-size: 12px;">*Processed {{homeValueDetails?.processedDate | date: 'MM/dd/yy'}} by
            {{homeValueDetails?.source}}*</p>
    </mat-dialog-content>
    <mat-dialog-actions class="float-end">
        <button mat-button (click)="onClose()">Close</button>
        <button class="btn btn-secondary" mat-button (click)="onSave()" [disabled]="!homeValueForm.valid">Save</button>
    </mat-dialog-actions>
</div>